<template>
    <!-- 测试上传组件 -->
    <div v-loading="loading" id="test">
      <div id="word">
         <!-- 学生项目立项 -->
        <studentProjectWord />   

  

         <!-- 创客专项资金及项目申请表（创客活动） -->
        <markeractivityWord/>
      </div>
     
    </div>
  </template>
  
  <script>
  // import MakerSpaceWord from '../components/MakerSpaceWord.vue'
  import BeUpload from "../components/tool/beUpload.vue";
  import getExcel from "@/components/tool/getExcel";
  import studentProjectWord from '@/components/studentProjectWord.vue'
  import markerFundWord from '../components/markerFundWord.vue';
  import markeractivityWord from '../components/markeractivityWord.vue';
  export default {
    components: {
      BeUpload,
      studentProjectWord,
      markerFundWord,
      markeractivityWord
    },
    data() {
      return {
        accept: "*",
        loading:false,

      };
    },
    methods: {
      getFile(val) {
        console.log(val);
      },
      Excel(){
        getExcel("数据")
      }
    },
  };
  </script>
  
  <style lang="less">
  #test{
    width: 100vw;
    display: flex;
    justify-content: center;
  }
  #word{
    width: 1350px;
    height: auto;
  }
    //去除input number样式
  input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"]{
      -moz-appearance: textfield;
  }
  </style>